import {
  fromJS
} from 'immutable';

import {
  SEARCH,
  LOAD_TRENDING,
  LOADING,
  MOVE_PAGE,
  SORT,
} from './constants';

const initialState = fromJS({

  query: null,
  influencers: [],

  page: 1,
  perPage: 24,

  order: null,

  showingTrending: true,
  isLoading: true,
  isError: false,
  searchPerformed: false,

});

function searchReducer(state = initialState, payload) {
  switch (payload.type) {
  case LOAD_TRENDING:
    return state
        .set('isLoading', payload.isLoading)
        .set('showingTrending', true)
        .set('influencers', payload.items);
  case LOADING:
    return state
        .set('isError', false)
        .set('errorMessage', null)
        .set('isLoading', payload.isLoading);
  case SEARCH:
    return state
        .set('isLoading', false)
        .set('searchPerformed', true)
        .set('query', payload.query)
        .set('showingTrending', false)
        .set('influencers', payload.items);
  case MOVE_PAGE:
    return state
        .set('page', payload.page);
  case SORT:
    return state
        .set('influencers', payload.items)
        .set('order', payload.order);
  default:
    return state;
  }
}

export default searchReducer;



// WEBPACK FOOTER //
// ./src/containers/search/reducer.js